import type { ReactNode } from 'react';

// One radio card in a delete-mode picker (the tenant delete dialog, the Tools
// bulk remover). Callers supply each mode's title and body.
export function DeleteModeOption<T extends string>({
  value,
  checked,
  onChange,
  title,
  body,
  name = 'delete-mode',
}: {
  value: T;
  checked: boolean;
  onChange: (v: T) => void;
  title: string;
  body: ReactNode;
  name?: string;
}) {
  return (
    <label
      className={`flex gap-3 p-3 rounded-md border cursor-pointer transition-colors ${
        checked ? 'border-slate-900 bg-slate-50' : 'border-slate-200 hover:border-slate-300'
      }`}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        className="mt-1 shrink-0"
      />
      <div className="min-w-0">
        <div className="text-sm font-medium text-slate-900">{title}</div>
        <div className="text-xs text-slate-600 mt-0.5">{body}</div>
      </div>
    </label>
  );
}
